import React, { useEffect, useRef } from 'react'
import { useParams } from 'react-router'
import { HeaderBar } from '../../component'
import Countdown from 'react-countdown'
import './style.css'
import * as documentAction from '../../redux/actions/document.action'
import { useDispatch, useSelector } from 'react-redux'
import { RootReducers } from '../../redux/reducers'
import { b64toBlob } from '../../helpers/base64'

declare global {
  interface Navigator {
    msSaveBlob?: (blob: any, defaultName?: string) => boolean
  }
}

export const Download: React.VFC = () => {
  const { id } = useParams()
  const dispatch = useDispatch()
  const documentData = useSelector((state: RootReducers) => state.documentReducer)
  const dwnldLnk = useRef(null)

  useEffect(() => {
    if (id) {
      dispatch(documentAction.handleGetDocument(id))
    }
  }, [])

  const downloadPDF = (content?: string) => {
    const link = dwnldLnk.current as unknown as HTMLAnchorElement
    if (link) {
      if (!documentData.isError && documentData.documentReponse?.result === 'SUCCESS') {
        const { contentId, mimeType, fileContent } = documentData.documentReponse
        const name = `${contentId?.split('/')[1] as string}.pdf`
        if (navigator.msSaveBlob) {
          return navigator.msSaveBlob((b64toBlob(fileContent, mimeType), name))
        }
        const url = window.URL.createObjectURL(b64toBlob(fileContent, mimeType))
        link.download = name
        link.href = url
        link.click()
        window.URL.revokeObjectURL(url)
      }
    }
  }

  const renderer = (data: any) => {
    const { seconds, completed } = data
    if (completed) {
      return 0
    } else {
      return <span>{seconds}</span>
    }
  }

  const DownloadLink = () => {
    if (documentData && documentData.isError) {
      return <div className="text-download-error">{documentData.documentReponse?.message}</div>
    } else {
      return (
        <div className="text-download-link">
          หากใบรับเงินชั่วคราวไม่ดาวน์โหลดเอง กรุณากด{' '}
          <a href="#" onClick={() => downloadPDF()}>
            {' '}
            ที่นี่
          </a>
        </div>
      )
    }
  }

  return (
    <div>
      <HeaderBar isSummary />
      <div className="container-summary">
        <div className="group-content">
          {/* <img className="img-status" alt="icon" /> */}
          <div className="text-download">
            <div className="text-download-header1">ขอบคุณสำหรับการดาวน์โหลด</div>
            <div className="text-download-header2">
              ใบรับเงินชั่วคราวจะดาวน์โหลดเองโดยอัตโนมัติ โปรดรอสักครู่
            </div>
            <div className="text-download-timer">
              Waiting time :{' '}
              <Countdown
                date={Date.now() + 5000}
                renderer={renderer}
                onComplete={() => downloadPDF()}
              />{' '}
              วินาที
            </div>

            <DownloadLink />
          </div>
        </div>
        <a id="dwnldLnk" ref={dwnldLnk} download="file.pdf" />
      </div>
    </div>
  )
}
